import React, {Component} from "react";
import axios from "axios";
import * as _ from "lodash";
import {authService} from "../../../auth";
import AnalyticsHeatMap from "../../../Analytics/AnalyticsHeatMap";
import uuid from "react-uuid";
import Select from 'react-select';
import AnalticsBarViewData from "../../../Analytics/AnalticsBarViewData";

const userFilterOption = (donorsCount, projectType) => [
    {label: "Project View", value: "VIEW"},
    {label: "Project Applied", value: "APPLIED"},
    {value: "DONATIONS", label: "Fund Raise", isDisabled: donorsCount > 0 && projectType !== "JOB" ? false : true}
]
class ProjectAnalyticssection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData :  authService.getUserDetailsFromLocalStorage(),
            showStatsSection: false,
            showAnalyticsSection: false,
            analyticsData: {},
            graphUpdatedValue: uuid(),
            toggleBar: "MAP",
            projectAnalyticsData: [],
            personaWiseAnalyticsData: [],
            showAnalyticsFlag: false,
            filterTypeOptionSelect: {label: "Project View", value: "VIEW"},
            personaUpdatedValue: uuid()
        }
    }

    showStatsSectionData = (flag, type) => {
        if(!flag) {
            this.getProjectStatsData();
        } else {
            this.setState({
                [type === "STATS_SECTION" ? "showStatsSection" : "showAnalyticsSection"]: false
            },() => {
                if(!this.state.showStatsSection) {
                    this.setState({
                        showAnalyticsSection: false
                    })
                }
            })
        }
    }

    showAnalyticsSectionData = (showAnalyticsSection) => {
        this.setState({
            showAnalyticsSection: !showAnalyticsSection
        })
    }

    getProjectStatsData = () => {
        let postData = {
            projectId: this.props.projectId,
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/recommend/projectwiseanalysis` ,
            headers: {'Content-Type': 'application/json'},
            data: postData,
            withCredentials: true
        }).then((response) => {
            if (response && response.data && response.data.data) {
                this.setState({
                    analyticsData: response.data.data,
                    showStatsSection: true,
                    showAnalyticsFlag: true
                }, () => {
                    if(Object.keys(this.state.analyticsData).length === 0) {
                        this.props.hideProjectStatsSection();
                    }
                })
            }
        }).catch((err) => {
            console.log(err);
            this.props.hideProjectStatsSection();
            this.setState({
                showStatsSection: true
            })
        });
    }

    onChangeFilterTypeOptionSelect = (value) => {
        this.setState({
            filterTypeOptionSelect: value,
        }, () => {
            this.getPersonaWiseAnalyticsData();
            this.getAnalyticsDataDetails("MAP");
        })
    }

    getPersonaWiseAnalyticsData = () => {
        this.getAnalyticsDataDetails("PERSONA");
    }

    getAnalyticsDataDetails = (type) => {
        let postData = {
            userId: this.state.userData.userId,
            size: 15,
            reason: type === "PERSONA" ? "persona" : "geography",
            projectId: this.props.projectId,
            type: type !== "PERSONA" ? type : null,
            dropdown_type: this.state.filterTypeOptionSelect && this.state.filterTypeOptionSelect.value
        }
        axios({
            url: `${process.env.REACT_APP_userServiceURL}/recommend/projectanalytics`,
            method: "POST",
            data: postData,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        }).then((response) => {
            if (response && response.data && response.data.data) {
                this.setState({
                    [type === "PERSONA" ?  "personaWiseAnalyticsData" : "projectAnalyticsData"]: response.data.data,
                    graphUpdatedValue: uuid(),
                    toggleBar: type !== "PERSONA" ? type : this.state.toggleBar
                },() => {
                    if(type === "PERSONA") {
                        this.setState({
                            personaUpdatedValue: uuid()
                        })
                    }
                    this.setState({
                        showAnalyticsFlag: ((this.state.personaWiseAnalyticsData && this.state.personaWiseAnalyticsData.PERSONA_WISE_GRAPH?.length > 0) || (this.state.projectAnalyticsData && this.state.projectAnalyticsData.COUNTRY_WISE_USER_HMAP?.length > 0)) ? true : false
                    })
                })
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    componentDidMount() {
        this.getProjectStatsData();
        this.getPersonaWiseAnalyticsData();
        this.getAnalyticsDataDetails("MAP");
    }

    render() {
        const {showStatsSection, showAnalyticsSection, analyticsData, graphUpdatedValue, projectAnalyticsData, personaWiseAnalyticsData, showAnalyticsFlag, filterTypeOptionSelect, personaUpdatedValue} = this.state;
        const { entityConfig, donorsCount } = this.props;
        return (
            <>
                {/* <div className="shortbydrop">
                    <a className="btn" href={"javascript: void(0)"} onClick={(e) => {e.preventDefault(); this.showStatsSectionData(showStatsSection, "STATS_SECTION");}}>
                        <i className="iBarGraphs"></i>{showStatsSection ? " Hide Stats" : " Show Stats"}
                    </a>
                </div> */}
                <h4>Project Stats</h4>
                {Object.keys(analyticsData).length > 0 &&
                    <div className="projtAnalyticsContent">
                        <div className="row">
                            {analyticsData.IMPRESSION !== 0 && 
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>No of impressions</h5>
                                        <p>{analyticsData.IMPRESSION}</p>
                                    </div>
                                </div>
                            }
                            {analyticsData.CLICKS !== 0 &&
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>No of clicks</h5>
                                        <p>{analyticsData.CLICKS}</p>
                                    </div>
                                </div>
                            }
                            {analyticsData.APPLICATION_RECIEVED !== 0 &&
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>Applications received</h5>
                                        <p>{analyticsData.APPLICATION_RECIEVED}</p>
                                    </div>
                                </div>
                            }
                            {analyticsData.APPLICATION_ACCEPTED !== 0 && 
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>Applications accepted</h5>
                                        <p>{analyticsData.APPLICATION_ACCEPTED}</p>
                                    </div>
                                </div>
                            }
                            {analyticsData.INVITED_PARTICIPANTS !== 0 && 
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>Invited participants</h5>
                                        <p>{analyticsData.INVITED_PARTICIPANTS}</p>
                                    </div>
                                </div>
                            }
                            {analyticsData.INVITED_ACCEPTED !== 0 && 
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>Invited accepted</h5>
                                        <p>{analyticsData.INVITED_ACCEPTED}</p>
                                    </div>
                                </div>
                            }
                            {analyticsData.TOTAL_ADMIN !== 0 && 
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>No of admins</h5>
                                        <p>{analyticsData.TOTAL_ADMIN}</p>
                                    </div>
                                </div>
                            }
                            {analyticsData.TOTAL_POST !== 0 && 
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>No of posts</h5>
                                        <p>{analyticsData.TOTAL_POST}</p>
                                    </div>
                                </div>
                            }
                            {analyticsData.STUDIO_COUNT !== 0 && 
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>Studio Count</h5>
                                        <p>{analyticsData.STUDIO_COUNT}</p>
                                    </div>
                                </div>
                            }
                            {analyticsData.VALUE !== 0 && 
                                <div className="col-md-6">
                                    <div className="projtAnalytBlk">
                                        <h5>Value</h5>
                                        <p>{this.props.projectType !== "FUNDRAISE" ? analyticsData.VALUE : "NA"}</p>
                                    </div>
                                </div>
                            }
                        </div>
                        
                        {showAnalyticsFlag && 
                            <div className="text-center" style={{marginTop: '5px'}}>
                                <a className="btn morebtnsm" href={"javascript: void(0)"} onClick={(e) => {e.preventDefault(); this.showAnalyticsSectionData(showAnalyticsSection)}}>
                                    {!showAnalyticsSection ? "Show Analytics" : "Hide Analytics"}
                                </a>
                            </div>
                        }
                        {showAnalyticsSection &&
                            <div className="analyticsPg">
                                <div className='row'>
                                    <div className='col-md-4 col-sm-6 col-12'>
                                        <Select
                                            placeholder={"Select type"}
                                            className="wnforSelect"
                                            name={"userFilterOption"}
                                            options={userFilterOption(donorsCount, this.props.projectType)}
                                            value={filterTypeOptionSelect}
                                            onChange={this.onChangeFilterTypeOptionSelect}
                                            styles={{
                                                option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                                    const color = '#cfe7c7';
                                                    return {
                                                        ...styles,
                                                        backgroundColor: isDisabled
                                                            ? null
                                                            : isSelected
                                                                ? '#cfe7c7'
                                                                : isFocused
                                                                    ? '#cfe7c7'
                                                                    : null,
                                                        color: isDisabled
                                                            ? '#ccc'
                                                            : isSelected
                                                                ? color > 2
                                                                    ? '#00374d'
                                                                    : '#00374d'
                                                                : data.color,
                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                        ':active': {
                                                            ...styles[':active'],
                                                            backgroundColor: !isDisabled && (isSelected ? '#cfe7c7' : '#cfe7c7'),
                                                        },
                                                    };
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                                <AnalticsBarViewData data={personaWiseAnalyticsData && personaWiseAnalyticsData.PERSONA_WISE_GRAPH} name={`Persona wise ${filterTypeOptionSelect.value === "VIEW" ? "Viewed by" : filterTypeOptionSelect.value === "APPLIED" ? "Applied by" : "Donated by"}`} key={personaUpdatedValue} entityConfig={entityConfig} selectData={this.state.filterTypeOptionSelect?.value} />
                                <div className="shortbydrop">
                                    <a onClick={() => this.getAnalyticsDataDetails("MAP")} className={this.state.toggleBar === "BAR" ? "btn" : "btn active"}><i className='imap' /> Map</a>
                                    <a onClick={() => this.getAnalyticsDataDetails("BAR")} className={this.state.toggleBar === "BAR" ? "btn active" : "btn"}><i className='iBarGraphs' /> Bar Graph</a>
                                </div>

                                {this.state.toggleBar === "BAR" ? 
                                    <AnalticsBarViewData data={projectAnalyticsData && projectAnalyticsData.COUNTRY_WISE_USER_BGRAPH} name={`Distribution of ${this.state.filterTypeOptionSelect?.value === "VIEW" ? "Viewers": this.state.filterTypeOptionSelect?.value === "APPLIED" ? "Applicants" : "Donors"}`} key={graphUpdatedValue} entityConfig={entityConfig} selectData={this.state.filterTypeOptionSelect?.value} /> :
                                    <AnalyticsHeatMap data={projectAnalyticsData && projectAnalyticsData.COUNTRY_WISE_USER_HMAP} name={`Distribution of ${this.state.filterTypeOptionSelect?.value === "VIEW" ? "Viewers": this.state.filterTypeOptionSelect?.value === "APPLIED" ? "Applicants" : "Donors"}`}  key={graphUpdatedValue} isProjectPage={true} entityConfig={entityConfig} selectData={this.state.filterTypeOptionSelect?.value} />}
                            </div>
                        }
                    </div>
                }
            </>
        );
    }
}

export default ProjectAnalyticssection;